import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";


const faqKeys = ["q1", "q2", "q3", "q4", "q5", "q6"];

export const FAQ = () => {
  const { t } = useTranslation();

  return (
    <section id="faq" className="py-16 md:py-24 px-4 bg-muted/30">
        <div className="container mx-auto max-w-4xl">
          <h2 className="font-clash text-3xl xs:text-4xl md:text-5xl font-bold text-center mb-12 text-foreground tracking-tight">
            {t("faq.headline")}
          </h2>

          <Accordion type="single" collapsible className="space-y-4">
            {faqKeys.map((key, index) => (
              <AccordionItem
                key={key}
                value={`item-${index}`}
                className="bg-card border-[3px] border-border rounded-lg px-6 shadow-md hover:shadow-lg hover:border-brand-teal/30 transition-all duration-150"
              >
                <AccordionTrigger className="text-left font-clash font-semibold text-base sm:text-lg text-foreground hover:text-brand-teal hover:no-underline py-6 leading-relaxed tracking-normal">
                  {t(`faq.${key}.question`)}
                </AccordionTrigger>
                <AccordionContent className="text-foreground/80 pb-6 leading-relaxed tracking-wide font-medium">
                  {t(`faq.${key}.answer`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
  );
};
